import Debug from 'debug';
const debug = Debug(`knack.core.helpers.entry.parsePhone`);
const phoneRegex = new RegExp(/[^0-9]+/, `g`);
export const parsePhone = (val, format) => {
    if (!val) {
        return ``;
    }
    // check for parts in case this is a copied value
    if (val.full) {
        return val;
    }
    val = String(val);
    const phone = {
        formatted: val
    };
    const parts = val.split(`x`);
    const ext = parts[1];
    if (ext) {
        phone.ext = ext;
    }
    switch (format.format) {
        case `+99 999 999 99?99`:
        case `+99 (0)999 999 99?99`: {
            const number = String(parts[0]).replace(phoneRegex, ``);
            phone.full = number;
            // We just got done regex'ing number, why are we doing it again?
            phone.country = String(number.substr(0, 2)).replace(phoneRegex, ``);
            if (format.format === `+99 (0)999 999 99?99`) {
                phone.area = number.substr(1, 3);
                phone.number = number.substr(4);
            }
            else {
                phone.area = number.substr(2, 3);
                phone.number = number.substr(5);
            }
            break;
        }
        case `(999) 999-9999`:
        case `999.999.9999`: {
            // split extension
            const number = String(parts[0]).replace(phoneRegex, ``);
            phone.full = number;
            phone.number = number;
            if (number.length === 10) {
                phone.number = number.substr(3);
                phone.area = number.substr(0, 3);
            }
            break;
        }
        case `99 9999 9999`:
        case `9999 999 999`: {
            const number = String(parts[0]).replace(phoneRegex, ``);
            phone.full = phone.number = number;
            break;
        }
        default: {
            const number = parts[0];
            phone.full = phone.number = number;
            break;
        }
    }
    return phone;
};
